import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* ABOUT */}
        <div className="footer-about">
          <h3>Embroidey Bazar</h3>

          <p>
            India's trusted marketplace for embroidery machines, workspaces, and
            skilled designers. Buy, rent, or hire — all in one place.
          </p>

          {/* <div className="footer-social">
            <a href="#">
              <i className="bi bi-facebook"></i>
            </a>

            <a href="#">
              <i className="bi bi-instagram"></i>
            </a>

            <a href="#">
              <i className="bi bi-whatsapp"></i>
            </a>

            <a href="#">
              <i className="bi bi-telegram"></i>
            </a>
          </div> */}
        </div>

        {/* MARKETPLACE */}
        <div className="footer-links">
          <h3>Marketplace</h3>

          <a href="/designes">Free Designs</a>
          <a href="/machine">Buy Machines</a>
          <a href="/house">Rent Workspace</a>
          <a href="/designer">Hire Designers</a>
        </div>

        {/* COMPANY */}
        <div className="footer-links">
          <h3>Company</h3>

          <a href="/home">Home</a>
          <a href="/contact">Contact Us</a>
          <a href="/about">About Us</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h3>Contact Us</h3>

          <p>
            Shop-17, UP GR Floor, Ranuja Complex, Near Riddhi Siddhi School,
            Vallabhacharya Road, Ashvani Kumar, Surat - 395008, Gujarat, India
          </p>

          <p>
            <i className="bi bi-envelope-fill"></i>
            info@example.com
          </p>

          <p>
            <i className="bi bi-telephone-fill"></i>
            99096 14445 / 98791 96990
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Embroidery Bazar. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
